/* app/js/src/components/recording/recording-scheduler/recording-job-sources/recording-job-sources.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: flex-start;
  justify-content: center;
}
.source {
  height: 18px;
  width: auto;
  line-height: 18px;
  margin-right: 5px;
  display: flex;
}
.source .failure {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}
.source span {
  font-size: 13px;
  line-height: 15px;
  cursor: pointer;
}
.source span:hover {
  text-decoration: underline;
}
.source .platform-name {
  font-weight: 400;
  cursor: default;
}
.source .platform-name:hover {
  text-decoration: none;
}
/*# sourceMappingURL=recording-job-sources.component.css.map */
